import { PLAN_DISCLOSURE_BLOCK } from "@/lib/disclosureTexts";

/**
 * Plan-level disclosure (Design Specification Sections 8.5, 9.4; compliance/01_texas_disclosures.md Section
 * 5). Rendered above and below the plan results list, and on plan detail below the cost table. Text is DRAFT,
 * not yet reviewed by outside counsel (see lib/disclosureTexts.js header) — this component only renders it,
 * never rewords it.
 */
export default function PlanDisclosureBlock({ effectiveDate, className = "", testId = "plan-disclosure" }) {
  const intro = effectiveDate ? `${PLAN_DISCLOSURE_BLOCK.intro.replace(/\.$/, "")} dated ${effectiveDate}.` : PLAN_DISCLOSURE_BLOCK.intro;
  return (
    <div
      className={`bg-[#E8EEF6] border-l-4 border-[#0A2540] rounded-r-xl p-4 md:p-5 text-sm text-[#0A2540] ${className}`}
      data-testid={testId}
      data-text-version={PLAN_DISCLOSURE_BLOCK.id}
      data-text-status={PLAN_DISCLOSURE_BLOCK.status}
    >
      <p>{intro} <strong>{PLAN_DISCLOSURE_BLOCK.controls}</strong></p>
      <p className="mt-2 text-[#475569]">{PLAN_DISCLOSURE_BLOCK.footer}</p>
    </div>
  );
}
